import React, { useState, useEffect, useRef } from "react";
import Navbar from "../../components/Navbar";
import { toast } from "react-toastify";
import Styles from "../../styles/gym/schedule.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { adminRoutes } from "../../routers/AdminRouters";
import Duplicate from "../../assets/session/dup-white.png";
import Duplicate_Image_URL from "../../assets/session/duplicate_dark.png";
import Close_Button from "../../assets/auth/close.png";
import Suceess from "../../assets/session/deletepopup.png";
import { useDispatch, useSelector } from "react-redux";
import {
  addGymSchedule,
  deleteGymSchedule,
  duplicateScheduleApi,
  getGym,
  getGymById,
  getScheduleGym,
  getSession,
} from "../../services";
import InfiniteScroll from "react-infinite-scroll-component";
import Swal from "sweetalert2";
import { toggle } from "../../redux";
import { FaSearch } from "react-icons/fa";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
const LIMIT = 7;

const ScheduleGym = () => {
  const { gymId } = useParams();
  const navigate = useNavigate();
  const { gym, gyms } = useSelector((state) => state.gym);
  const dispatch = useDispatch();
  const { sessions } = useSelector((state) => state.sessions);
  const isSidebarOpen = useSelector((state) => state.navbar.button);
  const { schedules } = useSelector((state) => state.gym);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [draggedTask, setDraggedTask] = useState(null);
  const selectedSessionsRef = useRef([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [displayedSessions, setDisplayedSessions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const handleMainContainerClick = () => {
    if (isSidebarOpen) {
      dispatch(toggle());
    }
  };

  useEffect(() => {
    const fetchGymData = async () => {
      if (gymId) {
        try {
          await getGymById(gymId);
          getScheduleGym(false, gymId);
          getGym();
        } catch (error) {
          console.error("Error fetching gym data:", error);
        }
      }
    };

    fetchGymData();
  }, [gymId]);
  const fetchSessions = async (pageNum = page, query = searchQuery, sort = sortOrder) => {
    if (loading) return;
  
    try {
      setLoading(true);
      const newSessions = await getSession(false, pageNum, LIMIT, query, sort);
  
      if (newSessions && Array.isArray(newSessions) && newSessions.length > 0) {
        setDisplayedSessions((prev) => {
          const uniqueSessions = [...prev];
          newSessions.forEach((session) => {
            if (!uniqueSessions.some((s) => s._id === session._id)) {
              uniqueSessions.push(session);
            }
          });
          return uniqueSessions;
        });
        setPage(pageNum + 1);
        setHasMore(newSessions.length === LIMIT);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching sessions:", error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchSessions();
  }, []);
  const handleSearch = async (e, sort = sortOrder) => {
    const query = e.target.value;
    setSearchQuery(query);
  
    try {
      setDisplayedSessions([]);
      setPage(1);
      
      if (query.trim() === "") {
        setHasMore(true);
        fetchSessions(1, "", sort);
      } else {
        // For actual queries, fetch with pagination still enabled
        const newSessions = await getSession(false, 1, LIMIT, query, sort);
        if (Array.isArray(newSessions)) {
          setDisplayedSessions(newSessions);
          setPage(2); // Set to page 2 for next fetch
          setHasMore(newSessions.length === LIMIT); // If we got a full page, there might be more
        } else {
          setHasMore(false);
        }
      }
    } catch (error) {
      console.error("Search error:", error);
      setHasMore(false);
    }
  };
  
  const handleDragStart = (task) => {
    setDraggedTask(task);
  };

  const handleDrop = (day) => {
    if (!draggedTask || !day) return;

    const today = new Date();
    today.setHours(0, 0, 0, 0); 
    const droppedDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      day
    );

    if (droppedDate < today) {
      toast.error("Not possible to drag item to a past date.");
      return;
    }

    const formattedDate = formatDate(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      day
    );

    handleSave(gymId, draggedTask._id, formattedDate);
    setDraggedTask(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const nextMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(1);
      newDate.setMonth(newDate.getMonth() + 1);
      return newDate;
    });
  };

  const prevMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(1);
      newDate.setMonth(newDate.getMonth() - 1);
      return newDate;
    });
  };

  const goToCurrentMonth = () => {
    setCurrentDate(new Date());
  };

  const getDaysInMonth = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    return Array(firstDay)
      .fill(null)
      .concat(Array.from({ length: daysInMonth }, (_, i) => i + 1));
  };
  const formatDate = (year, month, day) => {
    const formattedMonth = String(month).padStart(2, "0");
    const formattedDay = String(day).padStart(2, "0");
    return `${year}-${formattedMonth}-${formattedDay}`;
  };
  const handleSave = async (gymId, sessionId, date) => {
    try {
      const response = await addGymSchedule(gymId, sessionId, date);

      if (response) {
        if (!response._id) {
          console.error("No schedule ID returned from API");
          return;
        }
      } else {
        toast.error("Failed to schedule gym.");
      }
    } catch (error) {
      console.error("Error saving session:", error);
    }
  };

  const handleRemoveTask = async (scheduleId) => {
    if (!scheduleId) {
      console.error("Error: scheduleId is undefined");
      return;
    }

    Swal.fire({
      html: `
        <div style="text-align: center; border-radius: 20px; position: relative;">
          <button 
            id="customCloseButton" 
            style="position: absolute; top:-5px; right:-10px; background: none; border: none; cursor: pointer;">
            <img 
              src=${Close_Button} 
              alt="Close" 
              style="width: 40px; height: 40px;"
            />
          </button>
          <img 
            src=${Suceess} 
            alt="Success" 
            style="width: 100px; margin-bottom: 10px; margin-top: 15px;" 
          />
          <h2 style="color:#151515;text-align:center;font-family:gothambold; font-size:18px;margin-bottom: 10px; ">Are you sure?</h2>
          <p style="color:#2E292A;text-align:center;font-family:gotham_bookregular; line-height:22px; font-size:14px;margin-bottom: 10px; ">
            Do you really want to delete these details? This process cannot be undone.
          </p>
          <button 
            id="cancel" 
            style="background: linear-gradient(0deg, #151515 0%, #525252 100%); color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border: none; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Cancel
          </button>
          <br/>
          <button 
            id="delete" 
            style="background: #800505; color: #f3f3f6; padding: 10px 50px; font-size: 14px; font-family:gothambold; border-radius: 6px; cursor: pointer; margin-top: 10px;">
            Delete
          </button>
        </div>
      `,
      showConfirmButton: false,
      width: "400px",
      customClass: {
        popup: "custom-swal-container",
      },
      didOpen: () => {
        const cancel = document.getElementById("cancel");
        const deleteButton = document.getElementById("delete");
        const closeButton = document.getElementById("customCloseButton");

        cancel.addEventListener("click", () => {
          Swal.close();
        });

        deleteButton.addEventListener("click", async () => {
          try {
            Swal.close();
            console.log(`Deleting Schedule ID: ${scheduleId}`);

            const success = await deleteGymSchedule(scheduleId);
          } catch (error) {
            console.error("Error deleting schedule entry:", error);
            Swal.fire({
              icon: "error",
              title: "Error",
              text: "An error occurred while deleting the schedule.",
            });
          }
        });

        closeButton.addEventListener("click", () => {
          Swal.close();
        });
      },
    });
  };

  const handleCheckboxChange = (sessionId, isChecked) => {
    if (isChecked) {
      selectedSessionsRef.current = [...selectedSessionsRef.current, sessionId];
    } else {
      selectedSessionsRef.current = selectedSessionsRef.current.filter(
        (id) => id !== sessionId
      );
    }
  };

  const handleDuplicate = () => {
    const currentDate = new Date();
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);
    const startDate = nextDay.toISOString().split("T")[0];

    if (schedules.length === 0) {
      Swal.fire({
        title: "Error",
        text: "No past schedules found!",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const endDate =
      schedules.length > 0
        ? new Date(
            Math.max(...schedules.map((schedule) => new Date(schedule.date)))
          )
            .toISOString()
            .split("T")[0]
        : startDate;

    if (new Date(startDate) > new Date(endDate)) {
      Swal.fire({
        title: "Error",
        text: "The latest scheduled session has already ended. Cannot duplicate sessions.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const filteredGyms = gyms.filter((gymItem) => gymItem._id !== gym._id);

    const headerStyles = `
    background: var(--pop-top-bg, radial-gradient(798.09% 100% at 0% 49.32%, #E27908 0%, #7C4205 100%));
    color: #f3f3f6;
    text-align: left;
    padding: 15px;
    font-size: 18px;
    text-transform: uppercase;
    display: flex;
    font-family: vanguard_cf_boldbold;
    justify-content: space-between;
    letter-spacing: 1.2px;
    align-items: center;
`;

    const containerStyles = `
        text-align: left;
        padding: 0;
        background-color: #ffffff;
        border-radius: 10px;
        width: 650px;
        position: relative;
        overflow: hidden;
        border: 1px solid #ddd;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    `;

    const closeButtonStyles = `
        background: none;
        border: none;
        cursor: pointer;
        position: absolute;
        top: 15px;
        right: 15px;

    `;

    // Build HTML
    const tableHTML = `
        <div style="${containerStyles}">
            <div style="${headerStyles}">
                <span>ASSIGN SCHEDULED SESSIONS TO SELECTED GYM</span>
            </div>

            <button style="${closeButtonStyles}" id="customCloseButton">
                <img src="${Close_Button}" alt="Close" style="width: 25px; height: 25px;">
            </button>

<div style="padding: 15px; font-size: 16px; background-color:#252525; color:white; display: flex; justify-content: space-between; align-items: center;">
    
    <div style="display: flex; flex-direction: row; align-items: flex-start;justify-content: space-between;">
        <p style="margin: 0; color:rgb(255, 255, 255); font-family: 'gotham_bookregular'; font-weight: bold;">Gym Name:</p> 
        <span style="color: #F79328; font-family: 'gotham_bookregular';">${
          gym.name
        }</span>
    </div>

    <div style="display: flex; flex-direction: row; align-items: center;justify-content: space-between;">
        <p style="margin: 0; font-weight: bold;">Start Date:</p> 
        <span style="color: #F79328; font-family: 'gotham_bookregular';">${startDate}</span>
    </div>

    <div style="display: flex; flex-direction: row; align-items: flex-end;justify-content: space-between;">
        <p style="margin: 0; font-weight: bold;">End Date:</p> 
        <span style="color: #F79328; font-family: 'gotham_bookregular';">${endDate}</span>
    </div>

</div>



            <div style="max-height: 300px; overflow-y: auto; border-top: 1px solid #ddd; padding: 10px;">
                ${filteredGyms
                  .map((row, index) => {
                    const rowBackground =
                      index % 2 === 0 ? "#ffffff" : "#f4f4f4";

                    return `
                            <label style="display: flex; align-items: center; padding: 12px; border-bottom: 1px solid #ddd; cursor: pointer; font-size: 16px; background-color: ${rowBackground};">
                                <input type="checkbox" data-session-id="${
                                  row?._id
                                }" class="session-checkbox" style="margin-right: 10px; transform: scale(1.2);font-family: 'gotham_bookregular';font-size: 0.85rem;" />
                                ${row.name ?? ""}
                            </label>
                        `;
                  })
                  .join("")}
            </div>

            <div style="text-align: center; margin: 20px;">
                <button id="duplicateSelectedButton" style="display: inline-flex; height: 40px; padding: 10px 25px; justify-content: center; align-items: center; background-color: transparent; border: 1px solid #F79328; color: #21211C; border-radius: 8px; cursor: pointer; font-family: 'gothambold';">
                    <img src=${Duplicate_Image_URL} alt="Duplicate" style="width: 20px; height: 20px; margin-right: 10px;">
                    <span>Duplicate</span>
                </button>
            </div>
        </div>
    `;

    Swal.fire({
      html: tableHTML,
      showConfirmButton: false,
      width: "680px",
      background: "none",
      backdrop: false,
      customClass: {
        popup: "no-padding-modal",
      },
      didOpen: () => {
        const checkboxes = document.querySelectorAll(".session-checkbox");

        checkboxes.forEach((checkbox) => {
          const sessionId = checkbox.getAttribute("data-session-id");
          checkbox.checked = selectedSessionsRef.current.includes(sessionId);

          checkbox.addEventListener("change", (e) => {
            handleCheckboxChange(sessionId, e.target.checked);
          });
        });

        document
          .getElementById("duplicateSelectedButton")
          .addEventListener("click", async () => {
            if (selectedSessionsRef.current.length > 0) {
              Swal.fire({
                title: "Duplicate Sessions",
                text: "Some sessions already exist. Do you want to override them?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, override",
                cancelButtonText: "No, keep existing",
              }).then(async (result) => {
                const override = result.isConfirmed; // true if 'Yes', false if 'No'
                Swal.fire({
                  title: "Confirm Selection",
                  text: `Are you sure you want to proceed with these ${selectedSessionsRef.current.length} sessions?`,
                  icon: "question",
                  showCancelButton: true,
                  confirmButtonText: "Confirm",
                  cancelButtonText: "Cancel",
                }).then(async (finalResult) => {
                  if (finalResult.isConfirmed) {
                    try {
                      await duplicateScheduleApi(
                        gym._id,
                        selectedSessionsRef.current,
                        override
                      );
                      Swal.fire(
                        "Success",
                        "Sessions duplicated successfully!",
                        "success"
                      );
                    } catch (error) {
                      console.error("Error duplicating sessions:", error);
                      Swal.fire(
                        "Error",
                        "Failed to duplicate sessions.",
                        "error"
                      );
                    }
                  }
                });
              });
            } else {
              Swal.fire("Warning", "No sessions selected!", "warning");
            }
          });

        document
          .getElementById("customCloseButton")
          .addEventListener("click", () => Swal.close());
      },
    });
  };

  return (
    <>
      <Navbar />
      <div
        className={Styles.schedule_list_container_main}
        onClick={handleMainContainerClick}
      >
        <h2>
          <Link to={adminRoutes.dashboard} className={Styles.dark}>
            HOME&nbsp;
          </Link>
          <Link to={adminRoutes.listGym} className={Styles.white}>
            / SCHEDULE SESSIONS /
          </Link>
          <span className={Styles.orange}> {gym.name}</span>
        </h2>

        <div className={Styles.schedule_list_container}>
          <div className={Styles.table_container_heading}>
            <div className={Styles.table_container_headingone}>
              <p>Gym Name</p>
              <h3>{gym.name}</h3>
            </div>
            <div className={Styles.table_container_headingtwo}>
              {gyms.length <= 1 ? (
                <div className={Styles.create_new_session} disabled>
                  <img
                    src={Duplicate}
                    alt="Create Icon"
                    className={Styles.duplicateicon}
                  />
                  Duplication not allowed
                </div>
              ) : (
                <div
                  className={Styles.create_new_session}
                  style={{ cursor: "pointer" }}
                  onClick={handleDuplicate}
                >
                  <img
                    src={Duplicate}
                    alt="Create Icon"
                    className={Styles.duplicateicon}
                  />
                  Duplicate All Schedule
                </div>
              )}
            </div>
          </div>
          <hr />
          <div className={Styles.schedule_wrapper}>
            <div className={Styles.schedule_child_wrapper}>
              <div className={Styles.schedule_child_para}>
                <h1>Choose from list</h1>
                <div className={Styles.rightControls}>
                  <div
                    className={`${Styles.searchContainerchildtwo} ${
                      searchQuery ? Styles.active : ""
                    }`}
                  >
                    <FaSearch className={Styles.searchIcon} />
                    <input
                      type="text"
                      className={Styles.searchInput}
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                </div>
              </div>

              <div id="scrollableDiv" className={Styles.session_list}>
                <InfiniteScroll
                  dataLength={displayedSessions.length}
                  next={() => fetchSessions()}
                  hasMore={hasMore}
                  loader={
                    <div className={Styles.loadingSpinner}>
                      Loading more sessions...
                    </div>
                  }
                  endMessage={
                    <p style={{ textAlign: "center", padding: "10px" }}>
                      <b>No more sessions available</b>
                    </p>
                  }
                  scrollableTarget="scrollableDiv"
                  scrollThreshold={0.8}
                >
                  {displayedSessions && displayedSessions.length > 0 ? (
                    displayedSessions.map((session) => (
                      <div
                        key={session._id}
                        className={Styles.session_item}
                        draggable
                        onDragStart={() => handleDragStart(session)}
                      >
                        <span className={Styles.session_code}>
                          <strong>{session?.code || " "}</strong>
                        </span>
                        <span className={Styles.session_name}>
                          {session?.name || " "}
                        </span>
                      </div>
                    ))
                  ) : (
                    <p className={Styles.no_sessions}>No sessions available</p>
                  )}
                </InfiniteScroll>
              </div>

              <div className={Styles.calendar_container}>
                <div className={Styles.schedule_child_para}>
                  <h1>
                    Drag and drop sessions from the list to the desired date
                  </h1>
                </div>
                <div className={Styles.calendar_header}>
                  <div className={Styles.left_section}>
                    <button onClick={prevMonth} className={Styles.nav_btn}>
                      <MdArrowBackIos />
                    </button>
                    <h3 className={Styles.month_year}>
                      {currentDate.toLocaleString("default", {
                        month: "long",
                        year: "numeric",
                      })}
                    </h3>
                    <button onClick={nextMonth} className={Styles.nav_btn}>
                      <MdArrowForwardIos />
                    </button>
                  </div>

                  <div className={Styles.right_section}>
                    <button
                      className={Styles.today_btn}
                      onClick={goToCurrentMonth}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M14.1663 1.6665V4.1665M5.83301 1.6665V4.1665"
                          stroke="#F3F3F6"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.8333 2.9165H9.16667C6.02397 2.9165 4.45262 2.9165 3.47631 3.89281C2.5 4.86913 2.5 6.44047 2.5 9.58317V11.6665C2.5 14.8092 2.5 16.3806 3.47631 17.3568C4.45262 18.3332 6.02397 18.3332 9.16667 18.3332H10.8333C13.976 18.3332 15.5474 18.3332 16.5237 17.3568C17.5 16.3806 17.5 14.8092 17.5 11.6665V9.58317C17.5 6.44047 17.5 4.86913 16.5237 3.89281C15.5474 2.9165 13.976 2.9165 10.8333 2.9165Z"
                          stroke="#F3F3F6"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M2.91699 7.0835H17.0837"
                          stroke="#F3F3F6"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7.5 12.9165C7.5 12.9165 8.75 13.3332 9.16667 14.5832C9.16667 14.5832 10.9804 11.2498 13.3333 10.4165"
                          stroke="#F3F3F6"
                          strokeWidth="1.25"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      Today
                    </button>
                  </div>
                </div>

                <div className={Styles.calendar_day_labels}>
                  {["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"].map(
                    (day, index) => (
                      <div key={index} className={Styles.day_label}>
                        {day}
                      </div>
                    )
                  )}
                </div>
                <div className={Styles.calendar_grid}>
                  {getDaysInMonth().map((day, index) => {
                    const formattedDate = formatDate(
                      currentDate.getFullYear(),
                      currentDate.getMonth() + 1,
                      day
                    );

                    const today = new Date();
                    const date = new Date(
                      currentDate.getFullYear(),
                      currentDate.getMonth(),
                      day
                    );

                    const isToday =
                      today.toDateString() === date.toDateString();
                    const isPast = date < today && !isToday;
                    const isFuture = date > today;

                    const schedulesForDay = schedules
                      .filter(
                        (schedule) =>
                          formatDate(
                            new Date(schedule.date).getFullYear(),
                            new Date(schedule.date).getMonth() + 1,
                            new Date(schedule.date).getDate()
                          ) === formattedDate
                      )
                      .map((schedule) => ({
                        ...schedule,
                        code: schedule.session ? schedule.session.code : "",
                        name: schedule.session ? schedule.session.name : "",
                      }));

                    return (
                      <div
                        key={index}
                        onDragOver={handleDragOver}
                        onDrop={() => day && handleDrop(day)}
                        className={`
          ${Styles.calendar_cell} 
          ${isToday ? Styles.today_border : ""} 
          ${isPast ? Styles.past_day : ""} 
          ${isFuture && schedulesForDay.length > 0 ? Styles.future_day : ""}
        `}
                      >
                        {day || ""}
                        {schedulesForDay.length > 0 ? (
                          <div className={Styles.scheduled_task_container}>
                            {schedulesForDay.map((task, i) =>
                              task.code ? (
                                <div
                                  key={i}
                                  className={`${Styles.scheduled_task} ${
                                    isPast
                                      ? Styles.past_task
                                      : isToday
                                      ? Styles.today_task
                                      : Styles.future_task
                                  }`}
                                >
                                  <span>{task.code}</span>
                                  <button
                                    className={Styles.close_button}
                                    onClick={() => handleRemoveTask(task._id)}
                                  >
                                    ×
                                  </button>
                                </div>
                              ) : (
                                <></>
                              )
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    );
                  })}
                </div>
                <br />
                <div className={Styles.calender_notify_boxs}>
                  <div className={Styles.calender_box_child_one}>
                    <button disabled></button>
                    <span>Today</span>
                  </div>

                  <div className={Styles.calender_box_child_two}>
                    <button disabled></button> <span>Scheduled</span>
                  </div>

                  <div className={Styles.calender_box_child_three}>
                    <button disabled></button> <span>Completed</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className={Styles.button_group}>
            <button
              className={`${Styles.button} ${Styles.cancel_button}`}
              onClick={() => navigate(adminRoutes.listGym)}
            >
              Back
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ScheduleGym;
